import Typography from "@mui/material/Typography";
import WhiteCard from "../WhiteCard";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { PatientProfile } from "src/api/types";
import { useGetAnswersQuery } from "src/api/services/api";
import { useMemo } from "react";
import PatientVitals from "../PatientVitals";

interface Props {
  patient: PatientProfile;
}

const MedicationHistory = ({ patient }: Props) => {
  const { data } = useGetAnswersQuery({
    patient_id: patient.id,
  });

  const allergies = useMemo(() => {
    if (data == null) return "";

    const response = data.find(
      (answer) => answer.question.tag === "ALLERGY"
    )?.response;

    return response?.answer[0] || "No allergies";
  }, [data]);

  const medications = useMemo(() => {
    if (data == null) return "";

    const response = data.find(
      (answer) => answer.question.tag === "MEDICATIONS"
    )?.response;

    return response?.details ?? "No medications";
  }, [data]);

  return (
    <WhiteCard gap={2}>
      <Typography variant="subtitle2">MEDICAL HISTORY</Typography>
      <Stack>
        <Typography fontWeight={700}>Allergies</Typography>
        <Typography>{allergies}</Typography>
      </Stack>
      <Divider />
      <Stack>
        <Typography fontWeight={700}>Current medications</Typography>
        <Typography>{medications}</Typography>
      </Stack>
      <Divider />
      <PatientVitals patientId={patient.id} />
    </WhiteCard>
  );
};

export default MedicationHistory;
